import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Chip } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, MenuItem } from "@material-ui/core";
import FileBase from "react-file-base64";
import { red, green, blue } from "@material-ui/core/colors";

import { useDispatch, useSelector } from "react-redux";
import { propertyFetchThunk } from "../../features/properties/properties";

//hooks
import useModal from "../../Hooks/useModal";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const col = [
  "Title",
  "Author Name",
  "Status",
  "Area",
  "Size",
  "Edit",
  "Delete",
];

const getBadge = (status) => {
  switch (status) {
    case "approved":
      return green[500];
    case "pending":
      return blue[500];
    case "rejected":
      return red[500];
    default:
      return "primary";
  }
};

export default function MyProperties() {
  const user = JSON.parse(localStorage.getItem("user"));
  console.log(user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const { handleShow, handleClose, open } = useModal();
  const [Editdata, setEditdata] = React.useState({
    installment: {
      price: 0,
      number: 0,
    },
    selectedFile: [],
    _id: "",
    title: "",
    description: "",
    creator: "",
    size: "",
    featuredProperty: true,
    propertyType: "",
    area: "",
    keyFeatures: [],
    totalPayment: 0,
    downtownPayment: 0,
    room: 0,
    status: "pending",
    creatorID: "",
    authorName: "",
  });

  const propertyState = useSelector((state) => state.properties);
  // const filteresProperty = propertyState.properties.filter(
  //   (items) => items.creatorID === user.result._id
  // );
  // const filteresPropertycheck = propertyState.properties.filter((items) =>
  //   console.log(items.creator, user.result._id, "items")
  // );
  // console.log(filteresProperty, "filteresProperty");
  React.useEffect(() => {
    dispatch(propertyFetchThunk());
    return () => {};
  }, []);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Button
          variant="contained"
          color="primary"
          style={{ backgroundColor: "#fda94f" }}
          onClick={() => {
            setEditdata(null);
            handleShow();
          }}
        >
          Add Property
        </Button>
      </div>
      <TableContainer className="mt-4" component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              {col.map((item, i) => (
                <TableCell key={i} align={item == "Title" ? "left" : "center"}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {propertyState.properties
              .filter((item) => item.creator === user.result._id)
              .map((row, i) => (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    {row.title}
                  </TableCell>
                  <TableCell align="right">{row.authorName}</TableCell>
                  <TableCell align="right">
                    <Chip
                      label={row.status}
                      style={{
                        backgroundColor: getBadge(row.status),
                        color: "#fff",
                      }}
                    />
                  </TableCell>
                  <TableCell align="right">{row.area}</TableCell>
                  <TableCell align="right">{row.size}</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ backgroundColor: "#F0D500" }}
                      onClick={() => {
                        setEditdata(row);
                        handleShow();
                      }}
                    >
                      Edit
                    </Button>
                  </TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ backgroundColor: "#F32013" }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Entry open={open} handleClose={handleClose} Editdata={Editdata} />
    </>
  );
}

export const Entry = ({ handleClose, open, Editdata }) => {
  return (
    <div>
      <Formik
        initialValues={Editdata}
        initialErrors={initialValues}
        // validationSchema={loginSchema}
        onSubmit={(values, { setSubmitting }) => {
          console.log(values, "submit Data");
          // setTimeout(() => {
          //   alert(JSON.stringify(values, null, 2));
          //   setSubmitting(false);
          // }, 400);
        }}
      >
        {({
          isValid,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">
              {Editdata ? "Edit Property" : "Add Property"}
            </DialogTitle>
            <DialogContent>
              <TextField
                id="title"
                // defaultValue={Editdata.title}
                label="Enter Title"
                type="text"
                fullWidth
              />
              <TextField
                className="mt-4"
                id="description"
                label="Enter Description"
                multiline
                rows={4}
                defaultValue="Default Value"
                fullWidth
              />
              <TextField
                id="name"
                className="mt-2"
                name="size"
                label="Enter Size"
                type="text"
                fullWidth
              />
              <TextField
                id="featuredProperty"
                className="mt-2"
                name="featuredProperty"
                label="Featured Property"
                type="text"
                select
                fullWidth
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </TextField>

              <TextField
                id="area"
                className="mt-2"
                name="area"
                label="Enter Area"
                type="text"
                fullWidth
              />
              <TextField
                id="area"
                className="mt-2"
                name="area"
                label="Enter Area"
                type="text"
                fullWidth
              />
              <div className="mt-4">
                <FileBase
                  type="file"
                  multiple={false}
                  onDone={
                    ({ base64 }) => {}
                    // setPostData({ ...postData, selectedFile: base64 })
                  }
                />
              </div>
              <TextField
                id="price"
                className="mt-2"
                name="totalPayment"
                label="Enter Area"
                type="text"
                fullWidth
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                  handleClose();
                }}
                color="primary"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  );
};

const initialValues = {
  installment: {
    price: 0,
    number: 0,
  },
  selectedFile: [],
  _id: "",
  title: "",
  description: "",
  creator: "",
  size: "",
  featuredProperty: true,
  propertyType: "",
  area: "",
  keyFeatures: [],
  totalPayment: 0,
  downtownPayment: 0,
  room: 0,
  status: "pending",
  creatorID: "",
  authorName: "",
};
const loginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string().required("Required"),
  confirmPassword: Yup.string().required("Required"),
});
